import produce from 'immer';
import { uniqBy } from 'lodash';

export const fetchResponderInDomain = (actions, state) => {
  return produce(state, (draft) => {
    draft.responder.isFetching = actions.loadMore ? false : true;
    draft.responder.isLoadingMore = actions.loadMore;
    draft.responder.error = null;
  });
};

export const fetchResponderInDomainSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.responder.isFetching = false;
    draft.responder.isLoadingMore = false;
    draft.responder.isLast = actions.isLast;
    draft.responder.data = actions.data;
  });
};

export const fetchResponderInDomainFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.responder.isFetching = false;
    draft.responder.isLoadingMore = false;
    draft.responder.error = actions.error;
  });
};

// Get campaign in domain
export const fetchCampaignInDomain = (actions, state) => {
  return produce(state, (draft) => {
    draft.campaign.isFetching = actions.loadMore ? false : true;
    draft.campaign.isLoadingMore = actions.loadMore;
    draft.campaign.error = null;
  });
};

export const fetchCampaignInDomainSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.campaign.isFetching = false;
    draft.campaign.isLoadingMore = false;
    draft.campaign.isLast = actions.isLast;
    draft.campaign.data = actions.data;
  });
};

export const fetchCampaignInDomainFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.campaign.isFetching = false;
    draft.campaign.isLoadingMore = false;
    draft.campaign.error = actions.error;
  });
};

// Get all domain
export const baseGetAllDomain = () => {
  return {
    isFetchingDomainGroup: false,
    isFetchedDomainGroup: false,
    listDomainGroup: [],
    totalDomainGroup: 0,
    errorGetDomainGroup: null,
    isLast: false,
    isLoadingMore: false,
  };
};

export const fetchAllDomain = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainGroup = true;
  });
};

export const fetchAllDomainSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainGroup = false;
    draft.isFetchedDomainGroup = true;
    draft.listDomainGroup = uniqBy(actions.data, 'id');
    draft.totalDomainGroup = actions.total;
    draft.isLast = actions.isLast;
    draft.errorGetDomainGroup = null;
  });
};

export const fetchAllDomainFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainGroup = false;
    draft.errorGetDomainGroup = actions.error;
  });
};

export const fetchLoadMoreAllDomain = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingMore = true;
  });
};

export const fetchLoadMoreAllDomainSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingMore = false;
    draft.isLast = actions.isLast;
    draft.listDomainGroup = uniqBy([...draft.listDomainGroup, ...actions.data], 'id');
  });
};

export const fetchLoadMoreAllDomainFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isLoadingMore = false;
  });
};

// Search Domain
export const baseSearchDomain = () => {
  return {
    resultDomainSearch: [],
    isSearching: false,
    isSearched: false,
    errorSearchDomain: null,
  };
};

export const fetchSearchDomain = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSearching = true;
    draft.isSearched = false;
  });
};

export const fetchSearchDomainSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.resultDomainSearch = actions.data;
    draft.isSearching = false;
    draft.isSearched = true;
    draft.errorSearchDomain = null;
  });
};

export const fetchSearchDomainFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorSearchDomain = actions.error;
    draft.isSearching = false;
    draft.isSearched = true;
  });
};

export const fetchSearchDomainCancelled = (actions, state) => {
  return produce(state, (draft) => {
    draft.isSearching = false;
    draft.isSearched = false;
  });
};

// Save DID
export const baseDomainDetail = () => {
  return {
    isFetchingDomainInGroup: false,
    infoDomain: {
      domainsInGroup: [],
    },
    error: null,
  };
};

export const fetchLoadDomainInGroup = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainInGroup = true;
    draft.error = null;
  });
};

export const fetchLoadDomainInGroupSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainInGroup = false;
    draft.infoDomain = actions.infoDomain;
    draft.error = null;
  });
};

export const fetchLoadDomainInGroupFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingDomainInGroup = false;
    draft.error = actions.error;
  });
};

export const fetchLoadDomainGroupSetting = (actions, state) => {
  return produce(state, (draft) => {
    draft.infoDomain.setting = actions.infoDomain.setting;
    draft.error = null;
  });
};
